import { render, staticRenderFns } from "./EmojiCanvas.vue?vue&type=template&id=68229358"
import script from "./EmojiCanvas.vue?vue&type=script&lang=js"
export * from "./EmojiCanvas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports